var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "nav",
    { staticClass: "navbar has-shadow is-fixed-top is-primary" },
    [
      _c(
        "div",
        { staticClass: "navbar-brand" },
        [
          _c(
            "router-link",
            {
              staticClass: "navbar-item",
              attrs: {
                to: {
                  name: "home",
                  params: _vm.$route.params,
                },
              },
            },
            [
              _c("img", {
                staticClass: "p-1",
                attrs: {
                  src: require("@/assets/img/loghub_logo_trans.svg"),
                  alt: "",
                },
              }),
              _c("h1", [_vm._v(_vm._s(_vm.$t("app_name")))]),
            ]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "navbar-menu", attrs: { id: "navMenu" } }, [
        _c("div", { staticClass: "navbar-end" }, [
          _c(
            "div",
            {
              staticClass: "loghub-theme navbar-item",
              on: { click: _vm.toggleTheme },
            },
            [
              _vm.selectedTheme === "dark"
                ? _c("i", {
                    staticClass: "fas fa-sun is-size-4 is-size-6-mobile",
                  })
                : _vm._e(),
              _vm.selectedTheme === "light"
                ? _c("i", {
                    staticClass: "fas fa-moon is-size-4 is-size-6-mobile",
                  })
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.closeUserMenu,
                  expression: "closeUserMenu",
                },
              ],
              staticClass: "navbar-item has-dropdown",
              class: { "is-active": _vm.showUserMenu },
            },
            [
              _c(
                "a",
                {
                  staticClass: "navbar-link",
                  on: {
                    click: function ($event) {
                      _vm.showUserMenu = !_vm.showUserMenu
                    },
                  },
                },
                [_c("i", { staticClass: "fas fa-user is-size-5" })]
              ),
              _c("div", { staticClass: "navbar-dropdown is-right" }, [
                _c("div", { staticClass: "navbar-item" }, [
                  _vm._v(" " + _vm._s(_vm.$t("navbar.language")) + ": "),
                  _vm.isCurrentLanguage(_vm.Languages.SLOVAK)
                    ? _c("span", { staticClass: "has-l-m" }, [
                        _vm._v(_vm._s(_vm.$t("navbar.slovak"))),
                      ])
                    : _c(
                        "a",
                        {
                          staticClass: "has-l-m",
                          on: {
                            click: function ($event) {
                              return _vm.changeLanguage(_vm.Languages.SLOVAK)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("navbar.slovak")))]
                      ),
                  _vm.isCurrentLanguage(_vm.Languages.ENGLISH)
                    ? _c("span", { staticClass: "has-l-m" }, [
                        _vm._v(_vm._s(_vm.$t("navbar.english"))),
                      ])
                    : _c(
                        "a",
                        {
                          staticClass: "has-l-m",
                          on: {
                            click: function ($event) {
                              return _vm.changeLanguage(_vm.Languages.ENGLISH)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("navbar.english")))]
                      ),
                  _vm.isCurrentLanguage(_vm.Languages.CZECH)
                    ? _c("span", { staticClass: "has-l-m" }, [
                        _vm._v(_vm._s(_vm.$t("navbar.czech"))),
                      ])
                    : _c(
                        "a",
                        {
                          staticClass: "has-l-m",
                          on: {
                            click: function ($event) {
                              return _vm.changeLanguage(_vm.Languages.CZECH)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("navbar.czech")))]
                      ),
                ]),
                _c("div", { staticClass: "navbar-item" }, [
                  _c("table", { staticClass: "navbar-time-format-table" }, [
                    _c("tr", [
                      _c("td", { staticClass: "row-label" }, [
                        _vm._v(_vm._s(_vm.$t("navbar.date_format"))),
                      ]),
                      _c(
                        "td",
                        [
                          _c(
                            "b-field",
                            [
                              _c(
                                "b-select",
                                {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "placeholders.select_format"
                                    ),
                                  },
                                  on: { input: _vm.dateFormatSelected },
                                  model: {
                                    value: _vm.selectedDateFormat,
                                    callback: function ($$v) {
                                      _vm.selectedDateFormat = $$v
                                    },
                                    expression: "selectedDateFormat",
                                  },
                                },
                                _vm._l(_vm.DateFormats, function (option) {
                                  return _c(
                                    "option",
                                    {
                                      key: option,
                                      domProps: { value: option },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.dateTimeManager.formatTime(
                                              _vm.actualTime,
                                              _vm.selectedTimezone,
                                              option,
                                              ""
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "row-label" }, [
                        _vm._v(_vm._s(_vm.$t("navbar.time_format"))),
                      ]),
                      _c(
                        "td",
                        [
                          _c(
                            "b-field",
                            [
                              _c(
                                "b-select",
                                {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "placeholders.select_format"
                                    ),
                                  },
                                  on: { input: _vm.clockFormatSelected },
                                  model: {
                                    value: _vm.selectedClockFormat,
                                    callback: function ($$v) {
                                      _vm.selectedClockFormat = $$v
                                    },
                                    expression: "selectedClockFormat",
                                  },
                                },
                                _vm._l(_vm.ClockFormats, function (option) {
                                  return _c(
                                    "option",
                                    {
                                      key: option,
                                      domProps: { value: option },
                                    },
                                    [_vm._v(" " + _vm._s(option) + " ")]
                                  )
                                }),
                                0
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "row-label" }, [
                        _vm._v(_vm._s(_vm.$t("navbar.timezone"))),
                      ]),
                      _c(
                        "td",
                        [
                          _c(
                            "b-field",
                            [
                              _c(
                                "b-select",
                                {
                                  attrs: {
                                    expanded: "",
                                    placeholder: _vm.$t(
                                      "placeholders.select_format"
                                    ),
                                  },
                                  on: { input: _vm.timezoneSelected },
                                  model: {
                                    value: _vm.selectedTimezone,
                                    callback: function ($$v) {
                                      _vm.selectedTimezone = $$v
                                    },
                                    expression: "selectedTimezone",
                                  },
                                },
                                _vm._l(_vm.TimeZones, function (option) {
                                  return _c(
                                    "option",
                                    {
                                      key: option,
                                      domProps: { value: option },
                                    },
                                    [_vm._v(" " + _vm._s(option) + " ")]
                                  )
                                }),
                                0
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("tr", [
                      _c("td", { staticClass: "row-label" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("navbar.selected_format")) + " "
                        ),
                      ]),
                      _c("td", [
                        _c("p", { staticClass: "actual-time" }, [
                          _vm._v(_vm._s(_vm.actualTimeFormatted)),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm.needsReload()
                  ? _c("div", { staticClass: "navbar-item" }, [
                      _c("p", { staticClass: "reload-alert" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("error_messages.page_reload")) +
                            " "
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }